import { render } from "./GameView.vue?vue&type=template&id=4207b7c2"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=4207b7c2&lang=css"

import exportComponent from "/Users/peterdevos/Sites/tech_touch_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__